<template>
  <div class="hy-people">
    <!--列表-->
    <div class="people-list">
      <div class="rows">
        <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" v-if="data.length >0">
          <van-cell v-for="(items,index) in data" :key="index" @click="goPeopleInfo(index)">
            <router-link class="more-link"  :to="{ name: 'peopleInfo', params: { id: items.id }}">
              <div class="imgbox">
                <img :src="items.head_img" alt="">
              </div>
              <div class="textbox">
                <h5 class="hy_name">{{items.name}}</h5>
                <p class="hy_type">{{items.domain}}</p>
                <p class="hy_jigou">{{items.company}}</p>
              </div>
              <span class="iconfont cell-icon">&#xe699;</span>
            </router-link>
          </van-cell>
        </van-list>
      </div>
    </div>
    <!--底部按钮-->
    <footerFixed/>
  </div>
</template>


<script>
  import footerFixed from  '@/components/common/fixed_setting'
  export default {
    components: {
      footerFixed
    },
    data() {
      return {
        id:'',
        /* 全部会议 */
        data: [],
        peopleList: [],
        loading: false,
        finished: false,
        footerNav: false,
        page: 1,
        pagesize: 8,
      };
    },
    created() {
      var _this = this;
      this.id = this.$route.params.id;
      this.list();
      var wxShareInfo ={
        title:document.title,
        info:'嘉宾列表页',
        shareurl:window.location.href,
        img:document.images[0].currentSrc
      };
      _this.$WXConfig.wxShowMenu({ifshare:true,that:_this,data:wxShareInfo});
    },
    methods: {
      //储存本地作者信息
      goPeopleInfo(index){
        var _this = this;
        localStorage.setItem('guest', JSON.stringify(_this.data[index]));
      },
      //banner跳转方法
      goPath(path) {
        if (path == '') {
          return false;
        }
        this.$router.push(path)
      },
      //打开底部链接
      openFooterNav(val) {
        //   this.$toast(val);
        if (this.footerNav) {
          this.footerNav = false;
        } else {
          this.footerNav = true;
        }
      },
      //热门咨询加载
      onLoad() {
        // 异步更新数据
        // setTimeout 仅做示例，真实场景中一般为 ajax 请求
        setTimeout(() => {
          var _this = this;
          _this.page++;
          let url = "/ac1/conference/guestPaging";
          let params = {
            id: _this.id,
            page: _this.page,
            pagesize: _this.pagesize
          };
          _this.$get(url, params).then(res => {
            if (res.code == "1") {
              _this.peopleList = res.posts.guest_infos;
              _this.peopleList.forEach(v => {
                _this.data.push(v);
              });
                // 加载状态结束
            _this.loading = false;
            // 数据全部加载完成
            if (res.posts.guest_infos.length < _this.pagesize) {
              _this.finished = true;
            }
            }
          });

        }, 500);
      },
      list(pae) {
        var _this = this;
        let url = "/ac1/conference/guestPaging";
        let params = {
          id: _this.id,
          page: 1,
          pagesize: _this.pagesize
        };
        _this.$get(url, params).then(res => {
          if (res.code == "1") {
            _this.peopleList = res.posts.guest_infos;
            _this.peopleList.forEach(v => {
              _this.data.push(v);
            });
          }
        });
      }
    },
  }
</script>
<style lang="less" scoped>

</style>
